import React from 'react';

import PageHeader from './PageHeader';

/**
 * Header de rota cujo TÍTULO vem do backend — shim de L2 até o dado chegar.
 *
 * <p>Declarado como `headerComponent` no `PrivateRoutesConfig` (nível 2 da
 * prioridade de header do `MainPage`): renderiza no CLIQUE, antes do chunk lazy
 * do componente principal carregar. Quando o fetch termina, a página empurra o
 * header real via `setPageHeader` (nível 1) e este sai.
 *
 * <p>🔴 Existe porque o nível 3 (RouteHeader do config) mostraria o `title`
 * ESTÁTICO da rota — "Editar Dados da Escola" — e trocaria pelo nome da escola
 * quando o fetch voltasse. Título que troca na cara do usuário é pior que
 * ausência: ele lê, e o que leu muda.
 *
 * <p>⚠️ Genérico de propósito: L1 (crumbs) vem do `hierarchy` do config, já
 * montado pelo `MainPage` e repassado por prop. Só L2 shimmera. Rota nova não
 * precisa de componente próprio nem de config extra — só `headerComponent:
 * ShimHeader`.
 */
export default function ShimHeader({ crumbs, backTo, backLabel }) {
	return <PageHeader loading crumbs={crumbs} backTo={backTo} backLabel={backLabel} />;
}
